import { useT } from "../../shared/i18n";
import { Banner } from "../../shared/ui";

/** Explicit replacement for a panel the operator session may not use. */
export function PermissionDenied({ message }: { message: string }) {
  const t = useT();
  return (
    <Banner tone="warning" title={t("admin.denied.title")}>
      {message}
    </Banner>
  );
}
